import { render, staticRenderFns } from "./ConsentGroup.vue?vue&type=template&id=dd04f514&scoped=true&"
import script from "./ConsentGroup.vue?vue&type=script&lang=ts&"
export * from "./ConsentGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentGroup.vue?vue&type=style&index=0&id=dd04f514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd04f514",
  null
  
)

export default component.exports